import { Grid, Tabs, Tab, ThemeProvider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { observer } from 'mobx-react';
import React from 'react';
import { useRootStore } from 'store/StoreContextProvider';
import HomePageStore from '../store/HomePageStore';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';

interface Props {
  pageStore: HomePageStore;
}

const CustomTabs = styled(Tabs)`
  color: #ababab;

  .css-1a4240h-MuiButtonBase-root-MuiTab-root.Mui-selected {
    color: #000000;
  }
`;

const CustomTab = styled(Tab)`
  color: #ababab;

  & .Mui-selected {
    color: #000000;
  }
`;

function TopTabs(props: Props) {
  const { loginStore } = useRootStore();
  const { isPC } = useMediaQueryState();

  const handleTapChange = (event: React.SyntheticEvent, newValue: string) => {
    props.pageStore.setTabValue(newValue);
    props.pageStore.fetchTargetsByDeptCode(loginStore.currentUser);
  };
  return (
    <Grid container item direction='column' rowGap={2} style={{ width: isPC ? 500 : '100%' }}>
      <CustomTabs
        value={props.pageStore.tabValue}
        onChange={handleTapChange}
        variant='fullWidth'
        aria-label='topTabs_Home'
        TabIndicatorProps={{
          sx: {
            background: 'black',
          },
        }}
      >
        <CustomTab
          style={{
            textTransform: 'none',
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '15px',
            lineHeight: '15px',
          }}
          value={'downwards'}
          label='Downwards'
        />
        <CustomTab
          style={{
            textTransform: 'none',
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '15px',
            lineHeight: '15px',
          }}
          value={'peer'}
          label='Peer'
        />
        <CustomTab
          style={{
            textTransform: 'none',
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '15px',
            lineHeight: '15px',
          }}
          value={'all'}
          label='All'
        />
      </CustomTabs>
    </Grid>
  );
}

export default observer(TopTabs);
